import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiPaginate, ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';

@Injectable()

export class DashboardMultiProvider {
  private header = APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {}

  /**
   * Lista Indicadores
   * @param empresa Empresa do indicador
   * @param contrato Contrato do indicador
   * @param indicador Tipo do indicador
   * @param dtDe Data de inicio da consulta
   * @param dtAte Data de fim da consulta
   * @param tipoResultado Situação
   * @returns 
   */
  getIndicadores(empresa: string, contrato: string, indicador: string, dtDe: string, dtAte: string, tipoResultado: string): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `dashboard?operacao=invoice&empresa=${empresa}&contrato=${contrato}&indicador=${indicador}`

      if (dtDe && dtDe != "") {
        url += `&dtDe=${dtDe}`
      }

      if (dtAte && dtAte != "") {
        url += `&dtAte=${dtAte}`
      }

      if (tipoResultado && tipoResultado != "") {
        url += `&tipoResultado=${tipoResultado}`
      }
      
      me.http.get(url, { headers: me.header }).subscribe((result: any) => {
        if (result.status_ret != "NOK") {
          if (Array.isArray(result.data) && result.data.length != 0) {
            var datasuccess = {
              'Item': result,
              'erro': ''
            }

            me.itemret = datasuccess;
          } else {
            var errodatavazio = {
              'Item': null,
              'erro': 'Nenhum indicador encontrado.'
            }
  
            me.itemret = errodatavazio;
          }
        } else {
          var errodata = {
            'Item': null,
            'erro': 'Erro na consulta dos indicadores.'
          }
          
          me.itemret = errodata;
        }

        resolve(me.itemret);
      }, (error) => {
        var msg = "";

        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }

  /**
   * Lista Dados Demográficos
   * @param empresa Empresa do dado
   * @param contrato Contrato do dado
   * @param tipoDado Tipo do dado
   * @param dtDe Data de inicio da consulta
   * @param dtAte Data de fim da consulta
   * @param tipoResultado Situação
   * @returns 
   */
  getDadosDemograficos(empresa: string, contrato: string, tipoDado: string, dtDe: string, dtAte: string, tipoResultado: string): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `dashboard?operacao=demographics&empresa=${empresa}&contrato=${contrato}&tipoDado=${tipoDado}`

      if (dtDe && dtDe != "") {
        url += `&dtDe=${dtDe}`
      }

      if (dtAte && dtAte != "") {
        url += `&dtAte=${dtAte}`
      }

      if (tipoResultado && tipoResultado != "") {
        url += `&tipoResultado=${tipoResultado}`
      }
      
      me.http.get(url, { headers: me.header }).subscribe((result: any) => {
        if (result.status_ret != "NOK") {
          if (Array.isArray(result.data) && result.data.length != 0) {
            var datasuccess = {
              'Item': result,
              'erro': ''
            }

            me.itemret = datasuccess;
          } else {
            var errodatavazio = {
              'Item': null,
              'erro': 'Nenhum dado encontrado.'
            }
  
            me.itemret = errodatavazio;
          }
        } else {
          var errodata = {
            'Item': null,
            'erro': 'Erro na consulta dos dados demográficos.'
          }
          
          me.itemret = errodata;
        }

        resolve(me.itemret);
      }, (error) => {
        var msg = "";

        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }

  /**
   * Lista Dados Geográficos
   * @param empresa Empresa do dado
   * @param contrato Contrato do dado
   * @param dtDe Data de inicio da consulta
   * @param dtAte Data de fim da consulta
   * @param tipoResultado Situação
   * @returns 
   */
  getDadosGeograficos(empresa: string, contrato: string, dtDe: string, dtAte: string, tipoResultado: string): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `dashboard?operacao=geo&empresa=${empresa}&contrato=${contrato}`

      if (dtDe && dtDe != "") {
        url += `&dtDe=${dtDe}`
      }

      if (dtAte && dtAte != "") {
        url += `&dtAte=${dtAte}`
      }

      if (tipoResultado && tipoResultado != "") {
        url += `&tipoResultado=${tipoResultado}`
      }
      
      me.http.get(url, { headers: me.header }).subscribe((result: any) => {
        if (result.status_ret != "NOK") {
          if (Array.isArray(result.data) && result.data.length != 0) {
            var datasuccess = {
              'Item': result,
              'erro': ''
            }

            me.itemret = datasuccess;
          } else {
            var errodatavazio = {
              'Item': null,
              'erro': 'Nenhum dado encontrado.'
            }
  
            me.itemret = errodatavazio;
          }
        } else {
          var errodata = {
            'Item': null,
            'erro': 'Erro na consulta dos dados geográficos.'
          }
          
          me.itemret = errodata;
        }

        resolve(me.itemret);
      }, (error) => {
        var msg = "";

        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }

  /**
   * Lista Clientes por Modalidade
   * @param empresa Empresa do dado
   * @param contrato Contrato do dado
   * @param dtDe Data de inicio da consulta
   * @param dtAte Data de fim da consulta
   * @param tipoResultado Situação
   * @returns 
   */
  getModalidades(empresa: string, contrato: string, dtDe: string, dtAte: string, tipoResultado: string): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `dashboard?operacao=loyalty&empresa=${empresa}&contrato=${contrato}`

      if (dtDe && dtDe != "") {
        url += `&dtDe=${dtDe}`
      }

      if (dtAte && dtAte != "") {
        url += `&dtAte=${dtAte}`
      }

      if (tipoResultado && tipoResultado != "") {
        url += `&tipoResultado=${tipoResultado}`
      }
      
      me.http.get(url, { headers: me.header }).subscribe((result: any) => {
        if (result.status_ret != "NOK") {
          if (Array.isArray(result.data) && result.data.length != 0) {
            var datasuccess = {
              'Item': result,
              'erro': ''
            }

            me.itemret = datasuccess;
          } else {
            var errodatavazio = {
              'Item': null,
              'erro': 'Nenhum dado encontrado.'
            }
  
            me.itemret = errodatavazio;
          }
        } else {
          var errodata = {
            'Item': null,
            'erro': result.erro
          }
          
          me.itemret = errodata;
        }

        resolve(me.itemret);
      }, (error) => {
        var msg = "";

        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }

  /**
   * Lista percentual de vendas por Segmento
   * @param empresa Empresa do dado
   * @param contrato Contrato do dado
   * @param dtDe Data de inicio da consulta
   * @param dtAte Data de fim da consulta
   * @param tipoResultado Situação
   * @returns 
   */
  getSegmentos(empresa: string, contrato: string, dtDe: string, dtAte: string, tipoResultado: string): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `dashboard?operacao=segmentation&empresa=${empresa}&contrato=${contrato}`

      if (dtDe && dtDe != "") {
        url += `&dtDe=${dtDe}`
      }

      if (dtAte && dtAte != "") {
        url += `&dtAte=${dtAte}`
      }

      if (tipoResultado && tipoResultado != "") {
        url += `&tipoResultado=${tipoResultado}`
      }
      
      me.http.get(url, { headers: me.header }).subscribe((result: any) => {
        if (result.status_ret != "NOK") {
          if (Array.isArray(result.segmentacao) && result.segmentacao.length != 0) {
            var datasuccess = {
              'Item': result,
              'erro': ''
            }

            me.itemret = datasuccess;
          } else {
            var errodatavazio = {
              'Item': null,
              'erro': 'Nenhum dado encontrado.'
            }
  
            me.itemret = errodatavazio;
          }
        } else {
          var errodata = {
            'Item': null,
            'erro': result.erro
          }
          
          me.itemret = errodata;
        }

        resolve(me.itemret);
      }, (error) => {
        var msg = "";

        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }

  /**
   * Percentual da fatia de clientes do shopping pela loja (Visitantes e Compradores)
   * @param empresa Empresa do dado
   * @param contrato Contrato do dado
   * @param dtDe Data de inicio da consulta
   * @param dtAte Data de fim da consulta
   * @param tipoResultado Situação
   * @returns 
   */
  getShare(empresa: string, contrato: string, tipoDado: string, dtDe: string, dtAte: string, tipoResultado: string): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `dashboard?operacao=share&empresa=${empresa}&contrato=${contrato}&tipoDado=${tipoDado}`

      if (dtDe && dtDe != "") {
        url += `&dtDe=${dtDe}`
      }

      if (dtAte && dtAte != "") {
        url += `&dtAte=${dtAte}`
      }

      if (tipoResultado && tipoResultado != "") {
        url += `&tipoResultado=${tipoResultado}`
      }
      
      me.http.get(url, { headers: me.header }).subscribe((result: any) => {
        if (result.status_ret != "NOK") {
          var datasuccess = {
            'Item': result,
            'erro': ''
          }

          me.itemret = datasuccess;
        } else {
          var errodata = {
            'Item': null,
            'erro': result.erro
          }
          
          me.itemret = errodata;
        }

        resolve(me.itemret);
      }, (error) => {
        var msg = "";

        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }

  /**
   * Percentual da fatia de clientes do shopping pela loja (Visitantes e Compradores)
   * @param empresa Empresa do dado
   * @param contrato Contrato do dado
   * @param ano Ano da consulta
   * @param mes Mês consulta
   * @returns 
   */
  getMapaCalor(empresa: string, contrato: string, ano: string, mes: string): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `dashboard?operacao=heatmap&empresa=${empresa}&contrato=${contrato}&ano=${ano}&mes=${mes}`
      
      me.http.get(url, { headers: me.header }).subscribe((result: any) => {
        if (result.status_ret != "NOK") {
          var datasuccess = {
            'Item': result,
            'erro': ''
          }

          me.itemret = datasuccess;
        } else {
          var errodata = {
            'Item': null,
            'erro': result.erro
          }
          
          me.itemret = errodata;
        }

        resolve(me.itemret);
      }, (error) => {
        var msg = "";

        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }

  /**
   * Percentual da fatia de clientes do shopping pela loja (Visitantes e Compradores)
   * @param empresa Empresa do dado
   * @param contrato Contrato do dado
   * @returns 
   */
  getMapaCordas(empresa: string, contrato: string): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `dashboard?operacao=relationship&empresa=${empresa}&contrato=${contrato}`
      
      me.http.get(url, { headers: me.header }).subscribe((result: any) => {
        if (result.status_ret != "NOK") {
          var datasuccess = {
            'Item': result,
            'erro': ''
          }

          me.itemret = datasuccess;
        } else {
          var errodata = {
            'Item': null,
            'erro': result.erro
          }
          
          me.itemret = errodata;
        }

        resolve(me.itemret);
      }, (error) => {
        var msg = "";

        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }

  /**
   * Lista Faixa de Penetração - MultiVocê
   * @param empresa Empresa da faixa
   * @param contrato Contrato da faixa
   * @param tipoResultado Situação
   * @returns 
   */
  getFaixa(empresa: string, contrato: string, tipoResultado: string): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `dashboard?operacao=tier&empresa=${empresa}&contrato=${contrato}`

      if (tipoResultado && tipoResultado != "") {
        url += `&tipoResultado=${tipoResultado}`
      }
      
      me.http.get(url, { headers: me.header }).subscribe((result: any) => {
        if (result.status_ret != "NOK") {
            var datasuccess = {
              'Item': result,
              'erro': ''
            }

            me.itemret = datasuccess;
        } else {
          var errodata = {
            'Item': null,
            'erro': result.erro
          }
          
          me.itemret = errodata;
        }

        resolve(me.itemret);
      }, (error) => {
        var msg = "";

        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }

   /**
   * Lista Benefícios - MultiVocê
   * @param empresa Empresa da faixa
   * @param contrato Contrato da faixa
   * @param tipoResultado Situação
   * @returns 
   */
  getBeneficios(empresa: string, contrato: string): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `dashboard?operacao=beneficios&empresa=${empresa}&contrato=${contrato}`

      me.http.get(url, { headers: me.header }).subscribe((result: any) => {
        if (result.status_ret != "NOK") {
            var datasuccess = {
              'Item': result,
              'erro': ''
            }

            me.itemret = datasuccess;
        } else {
          var errodata = {
            'Item': null,
            'erro': result.erro
          }
          
          me.itemret = errodata;
        }

        resolve(me.itemret);
      }, (error) => {
        var msg = "";

        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }
}
